import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router';
import { cn } from '@/lib/cn';
import { mainNav } from '@/data/navigation';
import { Button } from '@/components/ui/Button';
import { MobileMenu } from './MobileMenu';
import { Menu } from '@/icons';

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header
        className={cn(
          'fixed top-0 left-0 right-0 z-40 transition-all duration-300',
          'backdrop-blur-xl',
          scrolled
            ? 'bg-bg/70 border-b border-border'
            : 'bg-transparent border-b border-transparent',
        )}
      >
        <div className="mx-auto max-w-[1440px] h-18 px-6 md:px-12 lg:px-20 flex items-center justify-between gap-8 py-4">
          <Link
            to="/"
            className="font-display font-black text-2xl tracking-tight leading-none focus-visible:outline-2 focus-visible:outline-accent"
            style={{ fontVariationSettings: '"opsz" 144, "SOFT" 0' }}
          >
            JUST SEE
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            <nav aria-label="Main" className="flex items-center gap-8">
              {mainNav.map((item) => (
                <NavLink
                  key={item.href}
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      'font-sans text-sm transition-colors duration-200 hover:text-accent',
                      isActive ? 'text-accent' : 'text-ink-primary',
                    )
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <Button to="/contact" variant="primary" className="py-3 px-5 text-sm">
              Start a project
            </Button>
          </div>

          <button
            type="button"
            className="lg:hidden p-2 -mr-2 text-ink-primary hover:text-accent cursor-pointer"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
      </header>
      <MobileMenu open={menuOpen} onOpenChange={setMenuOpen} />
    </>
  );
}
